import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SYSTEM_PATH_COMPANY } from "../../../App";
import { deleteProduct, getProductById } from "../../../http/api/ProductAPI";
import {
  deleteProductDetail,
  getProductDetailByProductId,
} from "../../../http/api/ProductDetailAPI";
import { CompanyTitledPage } from "../../TitledPage";
import DeleteProductDetailDialog from "../DeleteProductDetailDialog";
import ProductPageDeleteProductDialog from "../ProductPageDeleteProductDialog";
import { ChainStoreProductList } from "./ChainStoreProductList";
import ProductDetailList from "./ProductDetailList";
import ProductInfoTable from "./ProductInfoTable";
import ChainStoreInfoModal from "./ChainStore/ChainStoreInfoModal";
import {
  deleteChainStoreProduct,
  getChainStoreProduct,
} from "../../../http/api/ChainStoreAPI";
import DeleteChainStoreProductDialog from "../DeleteChainStoreProductDialog";
import DeleteProductDialog from "../DeleteProductDialog";

// 商品情報表示ページ
export default function ProductPage() {
  const location = useLocation();
  const productId = location.state.productId;
  const navigate = useNavigate();
  // 商品情報
  const [product, setProduct] = useState({});
  // 商品明細リスト
  const [listProductDetail, setListProductDetail] = useState([]);
  const [listChainStoreProduct, setListChainStoreProduct] = useState([]);

  useEffect(() => {
    if (productId != null) {
      GetProduct();
      GetListProductDetail();
      FetchChainStoreProduct();
    }
  }, [location]);

  // 商品取得
  async function GetProduct() {
    let response = await getProductById(productId);
    setProduct(response.listProductInfo[0]);
  }

  // 商品明細リスト取得
  async function GetListProductDetail() {
    let response = await getProductDetailByProductId(productId);
    setListProductDetail(response.listProductDetailInfo);
  }

  async function FetchChainStoreProduct() {
    const response = await getChainStoreProduct({productId});
    const listResponse = response.listChainStoreProductInfo;
    setListChainStoreProduct(listResponse);
  }

  const [deleteProductDialogMode, setDeleteProductDialogMode] = useState(0);
  const [deleteProductDetailDialogMode, setDeleteProductDetailDialogMode] =
    useState(0);
  const [
    deleteChainStoreProductDialogMode,
    setDeleteChainStoreProductDialogMode,
  ] = useState(0);

  const [selectedProduct, setSelectedProduct] = useState({
    productId: 0,
    productName: "",
    productNameKana: "",
    productClassLName: "",
    productClassMName: "",
    productClassSName: "",
    taxName: "",
    taxRate: "",
  });
  const [selectedProductDetail, setSelectedProductDetail] = useState({
    productId: 0,
    productName: "",
    productDetailId: 0,
    origin: "",
    rank: "",
    productClass: "",
    weight: "",
    weightUnit: "",
    orderingUnit: "",
    supplier: "",
  });

  const [selectedChainStoreProduct, setSelectedChainStoreProduct] = useState({
    productId: "",
    customerId: "",
    chainStoreProductTypeCd: "",
    chainStoreProductCd: "",
    chainStoreProductName: "",
  });

  // ダイアログを閉じる処理
  const onCloseDeleteProductDialog = (event) => {
    setDeleteProductDialogMode(0);
  };
  // ダイアログを閉じる処理
  const onCloseDeleteProductDetailDialog = (event) => {
    setDeleteProductDetailDialogMode(0);
  };

  // ダイアログを閉じる処理
  const onCloseDeleteChainStoreProductDialog = (event) => {
    setDeleteChainStoreProductDialogMode(0);
  };

  function onClickDeleteProduct(product) {
    setSelectedProduct(product);
    setDeleteProductDialogMode(2);
  }
  function onClickDeleteProductDetail(productDetail) {
    setSelectedProductDetail(productDetail);
    setDeleteProductDetailDialogMode(2);
  }
  function onClickDeleteChainStoreProduct(chainStoreProduct) {
    setSelectedChainStoreProduct(chainStoreProduct);
    setDeleteChainStoreProductDialogMode(2);
  }
  // 商品を削除
  async function onDeleteProduct(product) {
    let deleteParams = {
      productId: selectedProduct.productId,
      updatedId: "2", //TODO JWTでユーザIDを取得
    };
    try {
      //削除APIをコール
      await deleteProduct(deleteParams);
      //商品一覧画面に移動
      navigate(SYSTEM_PATH_COMPANY + "/product_master");
    } catch {
      console.log("商品を削除できなかった。");
    }
  }
  // 商品明細を削除
  async function onDeleteProductDetail(productDetail) {
    let deleteParams = {
      productId: selectedProductDetail.productId,
      productDetailId: selectedProductDetail.productDetailId,
      updatedId: "2", //TODO JWTでユーザIDを取得
    };
    try {
      //削除APIをコール
      await deleteProductDetail(deleteParams);

      //Stateのデータを削除する
      let newListProductDetail = listProductDetail.filter(
        (p) => p.productDetailId != selectedProductDetail.productDetailId
      );
      setListProductDetail(newListProductDetail);
    } catch {
      console.log("商品明細を削除できなかった。");
    }
  }
  // 商品明細を削除
  async function onDeleteChainStoreProduct() {
    const deleteParams = {
      productId: selectedChainStoreProduct.productId,
      customerId: selectedChainStoreProduct.customerId,
      chainStoreProductTypeCd:
        selectedChainStoreProduct.chainStoreProductTypeCd,
      chainStoreProductCd: selectedChainStoreProduct.chainStoreProductCd,
      chainStoreProductName: selectedChainStoreProduct.chainStoreProductName,
      updatedId: "2", //TODO JWTでユーザIDを取得
    };
    try {
      //削除APIをコール
      await deleteChainStoreProduct(deleteParams);
      //Stateのデータを削除する
      let newListChainStoreProduct = listChainStoreProduct.filter(
        (p) => p.customerId !== deleteParams.customerId
      );
      setListChainStoreProduct(newListChainStoreProduct);
    } catch {
      console.log("チェーンストア商品を削除できなかった。");
    }
  }
  return (
    <CompanyTitledPage title="商品情報表示">
      <ProductInfoTable
        product={product}
        onClickDeleteProduct={onClickDeleteProduct}
      />

      <ChainStoreProductList
        productId={productId}
        listChainStoreProduct={listChainStoreProduct}
        onClickDeleteChainStoreProduct={onClickDeleteChainStoreProduct}
        FetchChainStoreProduct={FetchChainStoreProduct}
      />

      <ProductDetailList
        productId={productId}
        listProductDetail={listProductDetail}
        onClickDeleteProductDetail={onClickDeleteProductDetail}
      />

      <ProductPageDeleteProductDialog
        open={deleteProductDialogMode === 2}
        product={selectedProduct}
        onCloseDialog={onCloseDeleteProductDialog}
        deleteAction={onDeleteProduct}
      />
      <DeleteProductDetailDialog
        open={deleteProductDetailDialogMode === 2}
        productDetail={selectedProductDetail}
        onCloseDialog={onCloseDeleteProductDetailDialog}
        deleteAction={onDeleteProductDetail}
      />
      <DeleteChainStoreProductDialog
        open={deleteChainStoreProductDialogMode === 2}
        chainStoreProduct={selectedChainStoreProduct}
        onCloseDialog={onCloseDeleteChainStoreProductDialog}
        deleteAction={onDeleteChainStoreProduct}
      />
    </CompanyTitledPage>
  );
}
